import { LicenseInfo } from "@mui/x-license";
import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import App from "./App";
import theme from "./theme";
import { AuthProvider } from "./contexts/AuthContext";
import AppProviders from "./contexts/AppProviders";

const licenseKey = process.env.REACT_APP_MUI_LICENSE_KEY;

if (licenseKey) {
  try {
    LicenseInfo.setLicenseKey(licenseKey);
  } catch (error) {
    console.error("Error setting license key:", error.message);
  }
} else {
  console.error(
    "MUI license key is missing. Please set REACT_APP_MUI_LICENSE_KEY."
  );
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <AuthProvider>
      <AppProviders>
        <App />
        </AppProviders>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
